module.exports = __webpack_public_path__ + "static/media/calender-icon.4bac9d55.svg";